module.exports = __webpack_public_path__ + "img/gPay-Gmail.4bd53623.svg";